import { useState, useEffect, useCallback } from 'react';
import api from '../../../api';

export const useClassManagerSubjects = ({
  tenantId,
  academicYearId,
  semesterId,
  departmentId,
  isSemesterBased
}) => {
  const [subjects, setSubjects] = useState({
    all: [],
    grouped: { semesterGroups: [], crossSemester: [], annual: [] },
    summary: null
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchSubjects = useCallback(async () => {
    // Require tenant + AY + department; semester is optional
    if (!tenantId || !academicYearId || !departmentId) return;

    setLoading(true);
    setError(null);

    try {
      const token = localStorage.getItem('token');
      const headers = token ? { Authorization: `Bearer ${token}` } : {};

      const params = {
        tenantId,
        academicYearId,
        departmentId
      };

      // only send semesterId when context is semester-based
      if (isSemesterBased && semesterId) {
        params.semesterId = semesterId;
      }

      const res = await api.get(
        '/api/subjects/class-manager/subjects/department/context',
        { headers, params }
      );

      const data = res.data?.data || {};
      const subj = data.subjects || {};
      const summary = data.summary || null;

      setSubjects({
        all: subj.all || [],
        grouped: {
          semesterGroups: subj.grouped?.semesterGroups || [],
          crossSemester: subj.grouped?.crossSemester || [],
          annual: subj.grouped?.annual || []
        },
        summary
      });
    } catch (err) {
      console.error('Error fetching class-manager subjects:', err?.response?.data || err);
      setError(
        err?.response?.data?.message ||
          'Failed to fetch subjects for this academic context'
      );
      setSubjects({
        all: [],
        grouped: { semesterGroups: [], crossSemester: [], annual: [] },
        summary: null
      });
    } finally {
      setLoading(false);
    }
  }, [tenantId, academicYearId, semesterId, departmentId, isSemesterBased]);

  useEffect(() => {
    fetchSubjects();
  }, [fetchSubjects]);

  return { subjects, loading, error, refetch: fetchSubjects };
};